"use client"
import React from 'react'

const ShowAfterFirstRender: React.FunctionComponent = ({ children }) => {
    const [show, setShow] = React.useState(false)

    React.useEffect(() => {
        setShow(true)
    }, [])

    return show ? (
        <>
            {children}
        </>
    ) : null
}

export default ShowAfterFirstRender